export const facebookUrl =
  'https://www.facebook.com/people/Iglesia-Tercer-Cielo/61590482106037/';
export const instagramUrl = 'https://www.instagram.com/iglesiacristianatercercielo';
export const mapUrl = 'https://share.google/qEC0rpcaka6PqP1gv';
export const mapEmbedUrl =
  'https://maps.google.com/maps?q=C.%20de%20la%20Caoba%201866%2C%2032599%20Ju%C3%A1rez%2C%20Chih.%2C%20M%C3%A9xico&z=17&hl=es&output=embed';

export const churchAddress = {
  street: 'C. de la Caoba 1866',
  locality: '32599 Juárez, Chih., México',
};

export const navigation = [
  { label: 'Inicio', href: '/' },
  { label: 'Visita', href: '/visita/' },
  { label: 'Eventos', href: '/eventos/' },
  { label: 'Mensajes', href: '/mensajes/' },
  { label: 'Contacto', href: '/contacto/' },
];

export interface Service {
  /** 0 = domingo … 6 = sábado (Date.getDay) */
  weekday: number;
  hour: number;
  minute: number;
  day: string;
  time: string;
  title: string;
  note: string;
}

export const services: Service[] = [
  {
    weekday: 0,
    hour: 10,
    minute: 30,
    day: 'Domingo',
    time: '10:30 a. m.',
    title: 'Clase dominical',
    note: 'Estudio bíblico para toda la familia.',
  },
  {
    weekday: 0,
    hour: 12,
    minute: 0,
    day: 'Domingo',
    time: '12:00 p. m.',
    title: 'Servicio general',
    note: 'Adoración, Palabra y comunión.',
  },
  {
    weekday: 2,
    hour: 19,
    minute: 0,
    day: 'Martes',
    time: '7:00 p. m.',
    title: 'Culto de oración',
    note: 'Una noche para buscar a Dios juntos.',
  },
  {
    weekday: 4,
    hour: 19,
    minute: 0,
    day: 'Jueves',
    time: '7:00 p. m.',
    title: 'Servicio general',
    note: 'Adoración, Palabra y comunión.',
  },
];
